import { computed, inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { filter, map, of, take } from "rxjs";
import { toObservable } from "@angular/core/rxjs-interop";
import { ProviderStore } from "../../../features/admin/state/provider.store";
import { ClinicStore } from "../../../features/admin/state/clinic.store";

export const getAllProvidersResolver: ResolveFn<any> = (route) => {
    const clinicStore = inject(ClinicStore)
    const providerStore = inject(ProviderStore)

    const cachedList = providerStore.entities()
    
    const clinic_id = Number(route.paramMap.get('clinic_id'))
    if (clinic_id && !Number.isNaN(clinic_id)) {
        clinicStore.setActiveClinicId(clinic_id)
        providerStore.setActiveClinicId(clinic_id)
    }

    if(cachedList.length > 0 ) return of(true)

    providerStore.loadAllProviders()

    return toObservable(
        computed(() => ({
            status: providerStore.providerStatus(),
            found: providerStore.entities().length > 0
        }))
    ).pipe(
        filter(({status}) => status === 'success' || status === 'error'),
        take(1),
        map(({found}) => found)
    )
}
